var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullnameicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4868 14.71L15.7268 15.85C15.9543 16.8356 15.7297 17.8713 15.1145 18.6742C14.4993 19.4771 13.5577 19.9633 12.5468 20H3.26683C2.25601 19.9633 1.3144 19.4771 0.699179 18.6742C0.0839581 17.8713 -0.140601 16.8356 0.0868326 15.85L0.326833 14.71C0.602868 13.1668 1.92945 12.0327 3.49683 12H12.3168C13.8842 12.0327 15.2108 13.1668 15.4868 14.71ZM12.5468 18.49C13.0546 18.4841 13.5325 18.2489 13.8468 17.85V17.86C14.2325 17.3762 14.3828 16.7458 14.2568 16.14L14.0168 15C13.8837 14.1552 13.1715 13.5226 12.3168 13.49H3.49684C2.6422 13.5226 1.93 14.1552 1.79684 15L1.55684 16.14C1.43399 16.7426 1.5841 17.3687 1.96684 17.85C2.28117 18.2489 2.75905 18.4841 3.26684 18.49H12.5468Z",
    fill: "#162033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40682 10H7.40682C5.19768 10 3.40682 8.20915 3.40682 6.00001V3.36001C3.40415 2.46807 3.75729 1.61189 4.388 0.981192C5.0187 0.350491 5.87488 -0.00265152 6.76682 1.49917e-05H9.04682C9.93876 -0.00265152 10.7949 0.350491 11.4256 0.981192C12.0563 1.61189 12.4095 2.46807 12.4068 3.36001V6.00001C12.4068 8.20915 10.616 10 8.40682 10ZM6.76682 1.50002C5.73957 1.50002 4.90682 2.33277 4.90682 3.36001V6.00001C4.90682 7.38073 6.02611 8.50001 7.40682 8.50001H8.40682C9.78753 8.50001 10.9068 7.38073 10.9068 6.00001V3.36001C10.9068 2.86671 10.7109 2.39361 10.362 2.0448C10.0132 1.69598 9.54012 1.50002 9.04682 1.50002H6.76682Z",
    fill: "#162033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullnameicon);
export default __webpack_public_path__ + "static/media/fullnameicon.a4b8b5fbf2818dc40df1600a9f97f72d.svg";
export { ForwardRef as ReactComponent };